import { cmnWhom } from './whom/index';
import { cmnTransNumber } from './transactionNumber/index';
import { renumberLines } from './renumberLines/index';
import { payrixPayment } from './payrixPayment';
import { forte2Payment } from './forte2Payment';

export const common = {
  namespaced: true,
  modules: {
    cmnWhom,
    cmnTransNumber,
    renumberLines,
    payrixPayment,
    forte2Payment,
  },
};

export default common;
